export enum SETTINGS_TAB_VALUES {
  EMAIL_NOTIFICATION = 'EMAIL_NOTIFICATION',
  VERIFICATION_OPTIONS = 'VERIFICATION_OPTIONS',
}
